class AuthService {
	setUser(data) {
		localStorage.setItem('user', JSON.stringify(data));
	}

	logout() {
		localStorage.removeItem('user');
	}

	clean() {
		localStorage.clear();
	}

	getUser() {
		return JSON.parse(localStorage.getItem('user'));
	}
}

export default new AuthService();
